 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"admin-chat~admin-stats~admin-users~generateLoginLink~home~live~loginView~postLogin~project~refresh-l~4104cffc":"admin-chat~admin-stats~admin-users~generateLoginLink~home~live~loginView~postLogin~project~refresh-l~4104cffc","admin-chat~admin-stats~faq~home~live~project~schedule~session~speaker~speakers~user-projects~whatsIncluded":"admin-chat~admin-stats~faq~home~live~project~schedule~session~speaker~speakers~user-projects~whatsIncluded","admin-chat~home~live~project~session~topic~topicApproval":"admin-chat~home~live~project~session~topic~topicApproval","admin-chat~home~live~session~topic":"admin-chat~home~live~session~topic","admin-chat":"admin-chat","home":"home","live":"live","session":"session","faq~project~speaker":"faq~project~speaker","project":"project","admin-stats":"admin-stats","topic":"topic","topicApproval":"topicApproval","admin-users":"admin-users","generateLoginLink":"generateLoginLink","loginView":"loginView","postLogin~purchaseConfirmation":"postLogin~purchaseConfirmation","postLogin":"postLogin","refresh-live-view":"refresh-live-view","share":"share","faq~speaker":"faq~speaker","faq":"faq","speaker":"speaker","schedule":"schedule","speakers":"speakers","user-projects":"user-projects","whatsIncluded":"whatsIncluded","auth":"auth","live-fb":"live-fb","liveinthelabs":"liveinthelabs","purchaseConfirmation":"purchaseConfirmation","privacy":"privacy","purchase":"purchase","recaptchaTest":"recaptchaTest","register":"register","social":"social","team":"team","tour":"tour","updateDisplayName":"updateDisplayName"}[chunkId]||chunkId) + "." + {"admin-chat~admin-stats~admin-users~generateLoginLink~home~live~loginView~postLogin~project~refresh-l~4104cffc":"b9bfe6dc","admin-chat~admin-stats~faq~home~live~project~schedule~session~speaker~speakers~user-projects~whatsIncluded":"f45241d2","admin-chat~home~live~project~session~topic~topicApproval":"9573a05d","admin-chat~home~live~session~topic":"e6218523","admin-chat":"b08fde2c","home":"cd7dadc7","live":"6311ef51","session":"07422ea9","faq~project~speaker":"72fbbb5c","project":"e813ed2d","admin-stats":"57a05c82","topic":"956294d5","topicApproval":"6f42bba0","admin-users":"bbc369a6","generateLoginLink":"5864cc7b","loginView":"19e8e258","postLogin~purchaseConfirmation":"54fb1fbb","postLogin":"5fa84d5d","refresh-live-view":"b31bc455","share":"8195417d","faq~speaker":"a1966616","faq":"5b352510","speaker":"1d0c638a","schedule":"343330f4","speakers":"af46a5b4","user-projects":"91f63258","whatsIncluded":"48abdca3","auth":"940b2330","live-fb":"c8d8e8da","liveinthelabs":"e71f7097","purchaseConfirmation":"ef832449","privacy":"3e32d6f5","purchase":"a55b078e","recaptchaTest":"b7df83f9","register":"61c17282","social":"341b9902","team":"b37a5ee0","tour":"15898788","updateDisplayName":"c127d157"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"admin-chat~home~live~session~topic":1,"admin-chat":1,"home":1,"live":1,"session":1,"project":1,"admin-stats":1,"topic":1,"loginView":1,"postLogin":1,"share":1,"speakers":1,"user-projects":1,"whatsIncluded":1,"liveinthelabs":1,"purchase":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"admin-chat~admin-stats~admin-users~generateLoginLink~home~live~loginView~postLogin~project~refresh-l~4104cffc":"admin-chat~admin-stats~admin-users~generateLoginLink~home~live~loginView~postLogin~project~refresh-l~4104cffc","admin-chat~admin-stats~faq~home~live~project~schedule~session~speaker~speakers~user-projects~whatsIncluded":"admin-chat~admin-stats~faq~home~live~project~schedule~session~speaker~speakers~user-projects~whatsIncluded","admin-chat~home~live~project~session~topic~topicApproval":"admin-chat~home~live~project~session~topic~topicApproval","admin-chat~home~live~session~topic":"admin-chat~home~live~session~topic","admin-chat":"admin-chat","home":"home","live":"live","session":"session","faq~project~speaker":"faq~project~speaker","project":"project","admin-stats":"admin-stats","topic":"topic","topicApproval":"topicApproval","admin-users":"admin-users","generateLoginLink":"generateLoginLink","loginView":"loginView","postLogin~purchaseConfirmation":"postLogin~purchaseConfirmation","postLogin":"postLogin","refresh-live-view":"refresh-live-view","share":"share","faq~speaker":"faq~speaker","faq":"faq","speaker":"speaker","schedule":"schedule","speakers":"speakers","user-projects":"user-projects","whatsIncluded":"whatsIncluded","auth":"auth","live-fb":"live-fb","liveinthelabs":"liveinthelabs","purchaseConfirmation":"purchaseConfirmation","privacy":"privacy","purchase":"purchase","recaptchaTest":"recaptchaTest","register":"register","social":"social","team":"team","tour":"tour","updateDisplayName":"updateDisplayName"}[chunkId]||chunkId) + "." + {"admin-chat~admin-stats~admin-users~generateLoginLink~home~live~loginView~postLogin~project~refresh-l~4104cffc":"31d6cfe0","admin-chat~admin-stats~faq~home~live~project~schedule~session~speaker~speakers~user-projects~whatsIncluded":"31d6cfe0","admin-chat~home~live~project~session~topic~topicApproval":"31d6cfe0","admin-chat~home~live~session~topic":"9c936ff1","admin-chat":"ca8bb074","home":"06309813","live":"c2447c9e","session":"e2499bc5","faq~project~speaker":"31d6cfe0","project":"d0010b19","admin-stats":"2f7ffc54","topic":"7db04b1c","topicApproval":"31d6cfe0","admin-users":"31d6cfe0","generateLoginLink":"31d6cfe0","loginView":"6fc8c922","postLogin~purchaseConfirmation":"31d6cfe0","postLogin":"6fc8c922","refresh-live-view":"31d6cfe0","share":"8b220ae0","faq~speaker":"31d6cfe0","faq":"31d6cfe0","speaker":"31d6cfe0","schedule":"31d6cfe0","speakers":"23d51e33","user-projects":"d75f1b1c","whatsIncluded":"6fc8c922","auth":"31d6cfe0","live-fb":"31d6cfe0","liveinthelabs":"d1f636b8","purchaseConfirmation":"31d6cfe0","privacy":"31d6cfe0","purchase":"e4596444","recaptchaTest":"31d6cfe0","register":"31d6cfe0","social":"31d6cfe0","team":"31d6cfe0","tour":"31d6cfe0","updateDisplayName":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
